module.exports = __webpack_public_path__ + "img/zgxd.207e9125.png";